module.exports = __webpack_public_path__ + "static/media/background.5ea30e69.svg";